import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { AppStore } from "../../../../redux/store";
import { toogleAction } from "../../../../redux/features/navigation";
import { isLoggedIn } from "../../../../helpers/authHelper";
import DropdownMenu from "./DropdownMenu";

export default function DropdownMenuUser() {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const user = useSelector((store: AppStore) => store.auth);
  const { visible: showNav } = useSelector((store: AppStore) => store.navigation);
  const logged = isLoggedIn(user);

  useEffect(() => {
    if (showNav) dispatch(toogleAction(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(() => {
    if (!logged && showNav) dispatch(toogleAction(false));
  }, [logged, showNav, dispatch]);

  useEffect(() => {
    if (!showNav) return;
    const close = () => dispatch(toogleAction(false));
    window.addEventListener("scroll", close, { passive: true });
    return () => window.removeEventListener("scroll", close);
  }, [showNav, dispatch]);

  if (!showNav) return null;

  const close = () => dispatch(toogleAction(false));

  return (
    <>
      <div className="fixed inset-0 z-[55]" onClick={close} />
      <DropdownMenu />
    </>
  );
}
